import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {SecuredZzFlatButton, ZzFlatButton, ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";
import {observable} from "mobx";
import {stripTime} from "core/common/utils/dateUtils";
import "shipment/page/shipmentRepackagingList.less";
import {ShipmentRepackagingResource} from "shipment/shipmentDomain";
import shipmentService from "shipment/shipmentService";
import {ShipmentRepackagingResourceDialog} from "shipment/component/shipmentRepackagingResourceDialog";
import {grey100} from "material-ui/styles/colors";
import moment from "moment";
import Grid from "core/grid/domain/grid";
import {ShipmentRepackagingUpdateDialog} from "shipment/component/shipmentRepackagingUpdateDialog";
import {BulkAction, BULKACTIONTYPE} from "core/grid/component/gridComp";


const gridLocation = 'shipmentRepackagingList';


@observer
export default class ShipmentRepackagingList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.shipment;
  static title = loc.i18n`Repackagings`;
  static icon = 'suitcase';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ShipmentRepackagingList#fetchData(%s)", gridLocation);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['ShipmentRepackagingResource']);
    let gridPromise = gridService.fetchGrids(gridLocation);
    return Promise.all([metadataPromise, gridPromise])
      .then(([mdEntityMap, gridLocationMap]) => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }

  private shipmentRepackagingResourceDialogRef: ShipmentRepackagingResourceDialog;
  private shipmentRepackagingUpdateDialogRef: ShipmentRepackagingUpdateDialog;
  private shipmentRepackagingResourceDialogRefHandler = comp => this.shipmentRepackagingResourceDialogRef = comp;
  shipmentRepackagingUpdateDialogRefHandler = comp => this.shipmentRepackagingUpdateDialogRef = comp;
  @observable resource: ShipmentRepackagingResource;
  @observable toolbarDate: Date = stripTime(new Date());



  advanceShipmentRepackagings = (grid: Grid) => {

    new Promise((resolve, reject) => {
      this.shipmentRepackagingUpdateDialogRef.open(resolve, reject, grid);
    }).then((res) => {
      return Promise.all([grid.search(null), shipmentService.readShipmentRepackagingResource(this.toolbarDate, {fillStatistics: true})])
    }).then(([x, srr]) => {
      this.resource = srr;
    }).catch( (error) => {
        console.log('rejecting ShipmentRepackagingUpdateDialog with ', error);
      });
  };


  componentDidMount() {
    return shipmentService.readShipmentRepackagingResource(this.toolbarDate, {fillStatistics: true})
      .then(srr => {
        this.resource = srr;
      })
  }


  render() {
    let {params, query} = this.props;

    let normLabel = (this.resource && this.resource.availableResources != null) ? ("Norma: " + this.resource.availableResources + " lidí * " + this.resource.dailyPalleteNorm + " palet = " + this.resource.getDailyNorm()) : "Nastavte normu";

    let normaCss = "";
    if (this.resource && this.resource.availableResources != null) {

      if (this.resource.completedThisDay >= this.resource.toRepackThisDay && this.resource.completedThisDay >= this.resource.getDailyNorm()) {
        // IF COMPLETED THIS DAY >= TO REPACK THIS DAY AND COMPLETED THIS DAY >= DAILY NORM - tak je zelená
        normaCss = "repackaging-norma-green repackaging-norma";
      } else if (this.resource.toRepackThisDay > this.resource.getDailyNorm() && this.resource.toRepackThisDay >= this.resource.completedThisDay) {
        // IF TO REPACK THIS DAY > DAILY NORM AND TO REPACK THIS DAY > COMPLETED THIS DAY (neboli že bude potřeba přesčas), tak oranžovou
        normaCss = "repackaging-norma-orange repackaging-norma";
      } else if (this.resource.toRepackThisDay >= this.resource.completedThisDay || this.resource.getDailyNorm() >= this.resource.completedThisDay) {
        // IF TO REPACK THIS DAY > COMPLETED THIS DAY OR DAILY NORM > COMPLETED THIS DAY, je červená
        normaCss = "repackaging-norma-red repackaging-norma";
      }
      if (moment(this.resource.workDate).isBefore(stripTime(new Date()))) {
        normaCss += " repackaging-norma-past";
      }
    }


    let bulkActions: BulkAction[] = [
      {type: BULKACTIONTYPE.ACTION, label: loc.i18n`Advance Repackagings`, fn: this.advanceShipmentRepackagings, that:this, securable: SECURABLE.shipmentRepackagingAdvance}
    ];


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap}
                         gridId={params.gridId} query={query} bulkActions={bulkActions}
                         multiUpdateSecurable={SECURABLE.shipmentRepackagingGridUpdate}>
        <ZzFlatButtonRoute onGridToolbar routeName="shipmentRepackagingDetail" params={{id: 'new'}}
                           label={loc.i18n`New Repackaging`} permission={PERMISSION.New}
                           securable={PAGE.shipmentRepackagingDetail}/>
        {(this.resource) ? (
          <div className="repackaging-info-box">
            <div style={{display: 'flex'}} className={normaCss}>
              <DatePicker name="toolbarDate" container="inline" mode="landscape" autoOk
                          DateTimeFormat={global.Intl.DateTimeFormat} locale={loc.lang} value={this.toolbarDate}
                          onChange={this.onToolbarDateChange} style={{width: 90, marginLeft:10}} inputStyle={(normaCss) ? {color: grey100} : {}}
                          textFieldStyle={{height: 40, fontSize: 14, cursor: 'pointer', width: 90}}/>
              <div style={{lineHeight: "40px", marginRight: 10}} title="Dnes hotovo / Dnešní plán k přebalu">{this.resource.completedThisDay + " / " + this.resource.toRepackThisDay}</div>
              <SecuredZzFlatButton name="setNorm" label={normLabel} permission={PERMISSION.Execute} style={(normaCss) ? {color: grey100} : {}}
                            securable={SECURABLE.shipmentRepackagingSetResource} onClick={this.onSetNorm}/>
            </div>
          </div>
        ) : null}

        <ShipmentRepackagingResourceDialog ref={this.shipmentRepackagingResourceDialogRefHandler}
                                           entities={mdEntityService.entityMap}/>
        <ShipmentRepackagingUpdateDialog ref={this.shipmentRepackagingUpdateDialogRefHandler} entities={mdEntityService.entityMap} />
      </GridCompConnected>
    );
  }


  onToolbarDateChange = (event, date) => {
    this.toolbarDate = date;
    return shipmentService.readShipmentRepackagingResource(this.toolbarDate, {fillStatistics: true})
      .then(srr => {
        this.resource = srr;
      })
  };


  onSetNorm = (e) => {
    console.log('onSetNorm')
    new Promise((resolve, reject) => {
      this.shipmentRepackagingResourceDialogRef.open(resolve, reject, this.toolbarDate, this.resource);
    }).then((res) => {
      return shipmentService.readShipmentRepackagingResource(this.toolbarDate, {fillStatistics: true})
        .then(srr => {
          this.resource = srr;
        })
    })
      .catch((error) => {
        console.log('rejecting shipmentRepackagingResourceDialog with ', error);
        return shipmentService.readShipmentRepackagingResource(this.toolbarDate, {fillStatistics: true})
          .then(srr => {
            this.resource = srr;
          })
      });
  }

}



// WEBPACK FOOTER //
// ./src/shipment/page/shipmentRepackagingList.tsx